import script from "./StorefrontPages.vue?vue&type=script&setup=true&lang=js"
export * from "./StorefrontPages.vue?vue&type=script&setup=true&lang=js"

import "./StorefrontPages.vue?vue&type=style&index=0&id=11f44118&scoped=true&lang=css"
import "./StorefrontPages.vue?vue&type=style&index=1&id=11f44118&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f44118"]])

export default __exports__